import { getExternalPath, getOrgProfileUrl, getUserProfileIdUrl } from "./urls";

export const parseMentions = (inputString: string): string => {
  // Replace user tags with links using a function
  inputString = inputString.replace(
    /@user:([^:]+):([0-9a-f-]{36})/g,
    (match, username, userId) => {
      return `[@${username}](${getExternalPath(getUserProfileIdUrl(userId))})`;
    }
  );

  // Replace org tags with links using a function
  inputString = inputString.replace(
    /@org:([^:]+):([0-9a-f-]{36})/g,
    (match, orgname, orgId) => {
      return `[@${orgname}](${getExternalPath(getOrgProfileUrl(orgId))})`;
    }
  );
  return inputString;
};

export const mentionHtmlToText = (htmlContent: string): string => {
  // Regular expression to match links with "/profiles/user-id/" in the href attribute
  const userLinkRegex =
    /<a[^>]*href="[^"]*\/profiles\/([A-Za-z0-9-]+)"[^>]*>@([^<]+)<\/a>/g;

  // Regular expression to match links with "/org/org-id/" in the href attribute
  const orgLinkRegex =
    /<a[^>]*href="[^"]*\/org\/([A-Za-z0-9-]+)"[^>]*>@([^<]+)<\/a>/g;

  // Replace user mentions
  const userFormattedContent = htmlContent.replace(
    userLinkRegex,
    (_, userId, username) => {
      return `@user:${username}:${userId}`;
    }
  );

  // Replace org mentions
  const orgFormattedContent = userFormattedContent.replace(
    orgLinkRegex,
    (_, orgId, orgName) => {
      return `@org:${orgName}:${orgId}`;
    }
  );

  const modifiedTextContent = orgFormattedContent
    .replaceAll(/&nbsp;/g, " ")
    .replaceAll("<strong>", "")
    .replaceAll("</strong>", "");

  return modifiedTextContent;
};
